var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSykepenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/32-content/box-2 Copy 2@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning",
    transform: "translate(-309.000000, -4950.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/40-health/first-aid-plaster",
    transform: "translate(309.000000, 4950.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFD399",
    points: "8.4 19.2036923 19.2036923 8.4 25.2 14.3963077 14.3963077 25.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2382397,2.2382397 C5.45718676,-0.980707364 10.9632979,-0.693540569 14.5364832,2.87964469 L19.1774476,7.52060908 C19.7408508,8.08401232 19.7408508,8.99746946 19.1774476,9.5608727 L9.5608727,19.1774476 C8.99746946,19.7408508 8.08401232,19.7408508 7.52060908,19.1774476 L2.87964469,14.5364832 C-0.693540569,10.9632979 -0.980707364,5.45718676 2.2382397,2.2382397 Z",
    id: "Rectangle",
    fill: "#FFBD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3617603,31.3617603 C28.1428132,34.5807074 22.6367021,34.2935406 19.0635168,30.7203553 L14.4225524,26.0793909 C13.8591492,25.5159877 13.8591492,24.6025305 14.4225524,24.0391273 L24.0391273,14.4225524 C24.6025305,13.8591492 25.5159877,13.8591492 26.0793909,14.4225524 L30.7203553,19.0635168 C34.2935406,22.6367021 34.5807074,28.1428132 31.3617603,31.3617603 Z",
    id: "Rectangle-Copy",
    fill: "#FFBD66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.200000, 4.200000)",
    fill: "#B26D14"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 0.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 7.7,
    cy: 2.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 4.9,
    cy: 4.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 0.7,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 2.1,
    cy: 7.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    cx: 6.3,
    cy: 9.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    cx: 9.1,
    cy: 6.3,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(19.600000, 19.600000)",
    fill: "#B26D14"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 0.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 7.7,
    cy: 2.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 4.9,
    cy: 4.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 0.7,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 2.1,
    cy: 7.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    cx: 6.3,
    cy: 9.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    cx: 9.1,
    cy: 6.3,
    r: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSykepenger);
export default __webpack_public_path__ + "static/media/Sykepenger.52e38054c18cb883d4dd9617d46914fd.svg";
export { ForwardRef as ReactComponent };